module.exports = __webpack_public_path__ + "static/media/nboost.553e6cd6.svg";